import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { useState } from 'react';

const SAPCompanyConfigModal = ({ show, onHide, onSave, initial }) => {
  const [form, setForm] = useState(
    initial ?? { companyDb: '', baseUrl: '', userName: '', password: '' });

  const change = (f, v) => setForm({ ...form, [f]: v });

  const handleSave = () => onSave(form);

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{initial ? 'Edit company' : 'New company'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className='mb-2'>
            <Form.Label>Company DB</Form.Label>
            <Form.Control
              value={form.companyDb}
              disabled={!!initial}
              onChange={e => change('companyDb', e.target.value)} />
          </Form.Group>
          <Form.Group className='mb-2'>
            <Form.Label>Base URL</Form.Label>
            <Form.Control
              value={form.baseUrl}
              onChange={e => change('baseUrl', e.target.value)} />
          </Form.Group>
          <Row>
            <Col>
              <Form.Group className='mb-2'>
                <Form.Label>User name</Form.Label>
                <Form.Control
                  value={form.userName}
                  onChange={e => change('userName', e.target.value)} />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className='mb-2'>
                <Form.Label>Password {initial && '(leave blank = unchanged)'}</Form.Label>
                <Form.Control type="password"
                  value={form.password}
                  onChange={e => change('password', e.target.value)} />
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onHide}>Cancel</Button>
        <Button variant='primary' onClick={handleSave}>Save</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SAPCompanyConfigModal;
